import { combineReducers } from 'redux'
import { createFullCycleHandlers } from 'utils/reducers'
import actions from 'actions/cms/interest-tag'
import state from './initial.state'

export default combineReducers({
  settings: createFullCycleHandlers(actions.settings, state.interest_tag.settings)
})
